module.exports = __webpack_public_path__ + "img/avatar1.99088c54.png";